// Recolher/abrir o menu (#o_collapse). No celular ele SEMPRE nasce recolhido e a escolha não é guardada.
const $ = window.jQuery;

const SidebarCollapse = function () {

    const MOBILE = '(max-width: 767px)';

    const alternar = function () {
        const body = document.body;
        const fechar = body.dataset.collapsed !== 'true';
        body.dataset.collapsed = fechar ? 'true' : 'false';
        $('#o_nav .nav-corpo').css('height', '');
        const txt = fechar ? 'Abrir menu' : 'Recolher menu';
        $(this).attr({ 'aria-label': txt, title: txt, 'aria-expanded': fechar ? 'false' : 'true' });
        setTimeout(() => window.dispatchEvent(new Event('resize')), 260);   // refaz filete e rolagem
    };

    return {
        init: function () {
            if (window.matchMedia(MOBILE).matches) document.body.dataset.collapsed = 'true';
            const $btn = $('#o_collapse');
            // Páginas podem nascer recolhidas ($sidebarCollapsed no Blade): o botão acompanha o estado.
            if (document.body.dataset.collapsed === 'true') $btn.attr({ 'aria-label': 'Abrir menu', title: 'Abrir menu', 'aria-expanded': 'false' });
            $btn.on('click', alternar);
        }
    };
}();

module.exports = SidebarCollapse;
